const RUNTIME_TAG_PLACEHOLDER = "__PREQUALS_RUNTIME_TAG__";

export const getMfeTag = (): string => {
  const runtimeTag = window.__PREQUALS_MFE_TAG;
  if (runtimeTag && runtimeTag !== RUNTIME_TAG_PLACEHOLDER) {
    return runtimeTag;
  }

  return process.env.REACT_APP_MFE_TAG || "latest";
};
